module.exports = __webpack_public_path__ + "media/images/connected-1-01d8e88786a4d085a9bab95c3d35fb2b.jpg";